export const SET_MESSAGE = "MESSAGE/SET_MESSAGE";
export const SET_CONNECTED_GUICHES = "CONNECTED_GUICHES/SET_CONNECTED_GUICHES";
